import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BeneficiaryType,
  EnrolledBeneficiaryType,
} from "../types/beneficiaries";

const initialState = {
  beneficiaries: [] as BeneficiaryType[],
  //selectedBeneficiary: {} as BeneficiaryType | null,
  selectedBeneficiary: {} as EnrolledBeneficiaryType | null,
};

const BeneficiarySlice = createSlice({
  name: "beneficiary",
  initialState,
  reducers: {
    setBeneficiaryData: (state, action: PayloadAction<BeneficiaryType[]>) => {
      state.beneficiaries = action.payload;
    },
    setSelectedBeneficiary: (
      state,
      action: PayloadAction<EnrolledBeneficiaryType>
    ) => {
      state.selectedBeneficiary = action.payload;
    },
    clearSelectedBeneficiary: (state) => {
      state.selectedBeneficiary = null;
    },
  },
});

export const {
  setBeneficiaryData,
  setSelectedBeneficiary,
  clearSelectedBeneficiary,
} = BeneficiarySlice.actions;

export default BeneficiarySlice.reducer;
